"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MangopayEventType = void 0;
var MangopayEventType;
(function (MangopayEventType) {
    MangopayEventType["PAYIN_NORMAL_CREATED"] = "PAYIN_NORMAL_CREATED";
    MangopayEventType["PAYIN_NORMAL_SUCCEEDED"] = "PAYIN_NORMAL_SUCCEEDED";
    MangopayEventType["PAYIN_NORMAL_FAILED"] = "PAYIN_NORMAL_FAILED";
    MangopayEventType["PAYOUT_NORMAL_CREATED"] = "PAYOUT_NORMAL_CREATED";
    MangopayEventType["PAYOUT_NORMAL_SUCCEEDED"] = "PAYOUT_NORMAL_SUCCEEDED";
    MangopayEventType["PAYOUT_NORMAL_FAILED"] = "PAYOUT_NORMAL_FAILED";
    MangopayEventType["TRANSFER_NORMAL_CREATED"] = "TRANSFER_NORMAL_CREATED";
    MangopayEventType["TRANSFER_NORMAL_SUCCEEDED"] = "TRANSFER_NORMAL_SUCCEEDED";
    MangopayEventType["TRANSFER_NORMAL_FAILED"] = "TRANSFER_NORMAL_FAILED";
    MangopayEventType["PAYIN_REFUND_CREATED"] = "PAYIN_REFUND_CREATED";
    MangopayEventType["PAYIN_REFUND_SUCCEEDED"] = "PAYIN_REFUND_SUCCEEDED";
    MangopayEventType["PAYIN_REFUND_FAILED"] = "PAYIN_REFUND_FAILED";
    MangopayEventType["PAYOUT_REFUND_CREATED"] = "PAYOUT_REFUND_CREATED";
    MangopayEventType["PAYOUT_REFUND_SUCCEEDED"] = "PAYOUT_REFUND_SUCCEEDED";
    MangopayEventType["PAYOUT_REFUND_FAILED"] = "PAYOUT_REFUND_FAILED";
    MangopayEventType["TRANSFER_REFUND_CREATED"] = "TRANSFER_REFUND_CREATED";
    MangopayEventType["TRANSFER_REFUND_SUCCEEDED"] = "TRANSFER_REFUND_SUCCEEDED";
    MangopayEventType["TRANSFER_REFUND_FAILED"] = "TRANSFER_REFUND_FAILED";
    MangopayEventType["KYC_CREATED"] = "KYC_CREATED";
    MangopayEventType["KYC_VALIDATION_ASKED"] = "KYC_VALIDATION_ASKED";
    MangopayEventType["KYC_SUCCEEDED"] = "KYC_SUCCEEDED";
    MangopayEventType["KYC_FAILED"] = "KYC_FAILED";
    MangopayEventType["PAYIN_REPUDIATION_CREATED"] = "PAYIN_REPUDIATION_CREATED";
    MangopayEventType["PAYIN_REPUDIATION_SUCCEEDED"] = "PAYIN_REPUDIATION_SUCCEEDED";
    MangopayEventType["PAYIN_REPUDIATION_FAILED"] = "PAYIN_REPUDIATION_FAILED";
    MangopayEventType["DISPUTE_DOCUMENT_CREATED"] = "DISPUTE_DOCUMENT_CREATED";
    MangopayEventType["DISPUTE_DOCUMENT_VALIDATION_ASKED"] = "DISPUTE_DOCUMENT_VALIDATION_ASKED";
    MangopayEventType["DISPUTE_DOCUMENT_SUCCEEDED"] = "DISPUTE_DOCUMENT_SUCCEEDED";
    MangopayEventType["DISPUTE_DOCUMENT_FAILED"] = "DISPUTE_DOCUMENT_FAILED";
    MangopayEventType["DISPUTE_CREATED"] = "DISPUTE_CREATED";
    MangopayEventType["DISPUTE_SUBMITTED"] = "DISPUTE_SUBMITTED";
    MangopayEventType["DISPUTE_ACTION_REQUIRED"] = "DISPUTE_ACTION_REQUIRED";
    MangopayEventType["DISPUTE_FURTHER_ACTION_REQUIRED"] = "DISPUTE_FURTHER_ACTION_REQUIRED";
    MangopayEventType["DISPUTE_CLOSED"] = "DISPUTE_CLOSED";
    MangopayEventType["DISPUTE_SENT_TO_BANK"] = "DISPUTE_SENT_TO_BANK";
    MangopayEventType["TRANSFER_SETTLEMENT_CREATED"] = "TRANSFER_SETTLEMENT_CREATED";
    MangopayEventType["TRANSFER_SETTLEMENT_SUCCEEDED"] = "TRANSFER_SETTLEMENT_SUCCEEDED";
    MangopayEventType["TRANSFER_SETTLEMENT_FAILED"] = "TRANSFER_SETTLEMENT_FAILED";
    MangopayEventType["MANDATE_CREATED"] = "MANDATE_CREATED";
    MangopayEventType["MANDATE_FAILED"] = "MANDATE_FAILED";
    MangopayEventType["MANDATE_ACTIVATED"] = "MANDATE_ACTIVATED";
    MangopayEventType["MANDATE_SUBMITTED"] = "MANDATE_SUBMITTED";
    MangopayEventType["PREAUTHORIZATION_PAYMENT_WAITING"] = "PREAUTHORIZATION_PAYMENT_WAITING";
    MangopayEventType["PREAUTHORIZATION_PAYMENT_EXPIRED"] = "PREAUTHORIZATION_PAYMENT_EXPIRED";
    MangopayEventType["PREAUTHORIZATION_PAYMENT_CANCELED"] = "PREAUTHORIZATION_PAYMENT_CANCELED";
    MangopayEventType["PREAUTHORIZATION_PAYMENT_VALIDATED"] = "PREAUTHORIZATION_PAYMENT_VALIDATED";
    MangopayEventType["UBO_DECLARATION_CREATED"] = "UBO_DECLARATION_CREATED";
    MangopayEventType["UBO_DECLARATION_VALIDATION_ASKED"] = "UBO_DECLARATION_VALIDATION_ASKED";
    MangopayEventType["UBO_DECLARATION_REFUSED"] = "UBO_DECLARATION_REFUSED";
    MangopayEventType["UBO_DECLARATION_VALIDATED"] = "UBO_DECLARATION_VALIDATED";
})(MangopayEventType || (exports.MangopayEventType = MangopayEventType = {}));
//# sourceMappingURL=MangopayEventType.js.map